/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2022 ICEMEDX, Inc.
***********************************************/
import { pharmacyindex } from "../domain/pharmacyindex";
export class pharmacystat extends pharmacyindex {
  public gettablename(): string {
    return "PHARMACY_STAT";
  }
}
